import React, { Fragment } from 'react';
import { Box, Container, Flex, Grid, Heading, Section, Text } from '@radix-ui/themes';
import { useSelector } from 'react-redux';
import { selectDevice } from 'store/slices/common';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

import Visual from 'components/common/visual';
import Breadcrumbs from 'components/common/breadcrumbs';
import PageTitle from 'components/layout/pageTitle';

import './style.scss';

// 소개 > 사업 소개 페이지
export default function Intro() {
  const deviceType = useSelector(selectDevice);
  const isMobile = deviceType === 'mobile';

  /**
    사업목적 데이터 
   */
  const goalSlideData = [
    {
      id: 0,
      src: require('assets/images/pages/intro/intro-title-1.png'),
      title: 'SW미래채움 센터구축',
      list: ['체험존', '교육장', '교구재']
    },
    {
      id: 1,
      src: require('assets/images/pages/intro/intro-title-2.png'),
      title: 'SW전문강사 양성',
      list: [
        '체계적인 SW교육을 통해 수준별 SW강사 양성 및 10개월 경력개발 지원',
        '지역 내 다양한 교육 수요 대응을 위한 역량강화 교육 및 활동 지원(자격증 등)'
      ]
    },
    {
      id: 2,
      src: require('assets/images/pages/intro/intro-title-3.png'),
      title: '초·중등학생 대상 SW 교육 운영',
      list: [
        '센터 교육 <br />- 최대 170시간 이상의 단계별 SW·AI 교육 <br />- AI, 메타버스, IoT, 드론 등 최신 기술 체험',
        '찾아가는 교육 <br />- 지역 내 교육수요를 기반으로 찾아가는 교육 추진 <br />- 지역 초·중등학교/도서벽지/특수학교/지역아동센터 등'
      ]
    }
  ];

  /**
    SW미래채움 주요성과 데이터 
   */
  const keyDataList = [
    {
      gridHeader: [
        {
          icon: false,
          alt: '',
          title: '2019~2023'
        },
        {
          icon: require('assets/images/icon/icon-sw-center.svg').default,
          alt: 'SW미래채움 주요성과',
          title: 'SW미래채움 센터구축'
        },
        {
          icon: require('assets/images/icon/icon-sw-teacher.svg').default,
          alt: 'SW전문강사 양성',
          title: 'SW전문강사 양성'
        },
        {
          icon: require('assets/images/icon/icon-sw-edu.svg').default,
          alt: '초·중등학생 교육 운영',
          title: '초·중등학생 교육 운영'
        },
        {
          icon: require('assets/images/icon/icon-sw-purpose.svg').default,
          alt: '주요 추진사항',
          title: '주요 추진사항'
        }
      ],
      gridBody: [
        {
          year: '2019',
          local_num: 5,
          local_new_list: '인천, 강원, 경남, 충북, 전남',
          local_prev_list: '',
          student: '504',
          person: '22,322',
          edu: '18,617',
          percent: '83.4%',
          history: ['SW미래채움 5개 센터 구축', '제1회 강사 네트워킹 데이 개최', 'SW강사 수업과정안 공모전 개최']
        },
        {
          year: '2020',
          local_num: 10,
          local_new_list: '경기, 충남, 제주, 경북, 울산',
          local_prev_list: '인천, 강원, 경남, 충북, 전남',
          student: '1,026',
          person: '39,480',
          edu: '34,096',
          percent: '86.4%',
          history: [
            'SW미래채움 5개 센터 추가 구축',
            '제2회 강사 네트워킹 데이 개최',
            'SW강사 수업과정안 공모전 개최',
            'SW교육 커리큘럼 가이드라인 개발',
            '고등부 글로벌 AI교육프로그램 운영 (인공지능 자율주행 과정)'
          ]
        },
        {
          year: '2021',
          local_num: 10,
          local_new_list: '',
          local_prev_list: '인천, 강원, 경남, 충북, 전남, 경기, 충남, 제주, 경북, 울산',
          student: '824',
          person: '110,991',
          edu: '94,191',
          percent: '84.9%',
          history: [
            'SW미래채움 10개 센터 운영',
            '제3회 강사 네트워킹 데이 개최',
            'SW강사 수업과정안 공모전 개최',
            '초·중학생 대상 코딩프로젝트 챌린지 개최',
            '고등부 글로벌 AI교육프로그램 운영(인공지능 자율주행, 데이터 사이언스 2개과정)'
          ]
        },
        {
          year: '2022',
          local_num: 11,
          local_new_list: '대구',
          local_prev_list: '인천, 강원, 경남, 충북, 전남, 경기, 충남, 제주, 경북, 울산',
          student: '922',
          person: '156,207',
          edu: '127,246',
          percent: '81.5%',
          history: [
            'SW미래채움 1개 센터 추가 운영',
            '제4회 강사 네트워킹 데이 개최',
            'SW강사 수업과정안 공모전 개최',
            '초·중학생 대상 코딩프로젝트 챌린지 개최',
            '고등부 글로벌 AI교육프로그램 운영',
            'SW강사 민간자격증 도입'
          ]
        },
        {
          year: '2023',
          local_num: 13,
          local_new_list: '광주, 전북',
          local_prev_list: '인천, 강원, 경남, 충북, 전남, 경기, 충남, 제주, 경북, 울산, 대구',
          student: '1,181',
          person: '253,742',
          edu: '213,847',
          percent: '84.3%',
          history: [
            'SW미래채움 2개 센터 추가 운영',
            '제5회 강사 네트워킹 데이 개최',
            'SW강사 수업과정안 공모전 개최',
            '초·중학생 대상 코딩프로젝트 챌린지 개최',
            '고등부 글로벌 코딩챌린지 개최',
            'SW미래채움 역량강화 교육 추진',
            'SW미래채움 늘봄학교 협력'
          ]
        }
      ]
    }
  ];
  const keyDataListMo = [
    {
      id: 0,
      year: '2019',
      center: {
        title: 'SW미래채움 센터구축',
        total: '5개 지역',
        local: ['<span>(신규)</span> 인천, 강원, 경남, 충북, 전남']
      },
      teacher: {
        title: 'SW전문강사 양성',
        total: '204명 양성'
      },
      education: {
        title: '초·중등학생 교육 운영',
        total: '22,322명',
        edu: '찾아가는 교육 : 18,6117명(83.4%)'
      },
      promotion: {
        title: '주요 추진사항',
        list: ['SW미래채움 5개 센터 구축', '제1회 강사 네트워킹 데이 개최', 'SW강사 수업과정안 공모전 개최']
      }
    },
    {
      id: 1,
      year: '2020',
      center: {
        title: 'SW미래채움 센터구축',
        total: '10개 지역',
        local: ['<span>(계속)</span> 인천, 강원, 경남, 충북, 전남', '<span>(신규)</span> 경기, 충남, 제주, 경북, 울산']
      },
      teacher: {
        title: 'SW전문강사 양성',
        total: '1,026명 양성'
      },
      education: {
        title: '초·중등학생 교육 운영',
        total: '39,480명',
        edu: '찾아가는 교육 : 34,096명(86.4%)'
      },
      promotion: {
        title: '주요 추진사항',
        list: [
          'SW미래채움 5개 센터 추가 구축',
          '제2회 강사 네트워킹 데이 개최',
          'SW강사 수업과정안 공모전 개최',
          'SW교육 커리큘럼 가이드라인 개발',
          '고등부 글로벌 AI교육프로그램 운영 (인공지능 자율주행 과정)'
        ]
      }
    },
    {
      id: 2,
      year: '2021',
      center: {
        title: 'SW미래채움 센터구축',
        total: '10개 지역',
        local: ['<span>(계속)</span> 인천, 강원, 경남, 충북, 전남, 경기, 충남, 제주, 경북, 울산']
      },
      teacher: {
        title: 'SW전문강사 양성',
        total: '824명 양성'
      },
      education: {
        title: '초·중등학생 교육 운영',
        total: '110,991명',
        edu: '찾아가는 교육 : 94,191명(84.9%)'
      },
      promotion: {
        title: '주요 추진사항',
        list: [
          'SW미래채움 10개 센터 운영',
          '제3회 강사 네트워킹 데이 개최',
          'SW강사 수업과정안 공모전 개최',
          '초·중학생 대상 코딩프로젝트 챌린지 개최',
          '고등부 글로벌 AI교육프로그램 운영(인공지능 자율주행, 데이터 사이언스 2개과정)'
        ]
      }
    },
    {
      id: 3,
      year: '2022',
      center: {
        title: 'SW미래채움 센터구축',
        total: '11개 지역',
        local: ['<span>(계속)</span> 인천, 강원, 경남, 충북, 전남, 경기, 충남, 제주, 경북, 울산', '<span>(신규)</span> 대구']
      },
      teacher: {
        title: 'SW전문강사 양성',
        total: '849명 양성'
      },
      education: {
        title: '초·중등학생 교육 운영',
        total: '156,207명',
        edu: '찾아가는 교육 : 127,246명(81.5%)'
      },
      promotion: {
        title: '주요 추진사항',
        list: [
          'SW미래채움 1개 센터 추가 운영',
          '제4회 강사 네트워킹 데이 개최',
          'SW강사 수업과정안 공모전 개최',
          '초·중학생 대상 코딩프로젝트 챌린지 개최',
          '고등부 글로벌 AI교육프로그램 운영',
          'SW강사 민간자격증 도입'
        ]
      }
    },
    {
      id: 4,
      year: '2023',
      center: {
        title: 'SW미래채움 센터구축',
        total: '13개 지역',
        local: ['<span>(계속)</span> 인천, 강원, 경남, 충북, 전남, 경기, 충남, 제주, 경북, 울산, 대구', '<span>(신규)</span> 광주, 전북']
      },
      teacher: {
        title: 'SW전문강사 양성',
        total: '1,181명 양성'
      },
      education: {
        title: '초·중등학생 교육 운영',
        total: '253,742명',
        edu: '찾아가는 교육 : 213,847명(84.3%)'
      },
      promotion: {
        title: '주요 추진사항',
        list: [
          'SW미래채움 2개 센터 추가 운영',
          '제5회 강사 네트워킹 데이 개최',
          'SW강사 수업과정안 공모전 개최',
          '초·중학생 대상 코딩프로젝트 챌린지 개최',
          '고등부 글로벌 코딩챌린지 개최',
          'SW미래채움 역량강화 교육 추진',
          'SW미래채움 늘봄학교 협력'
        ]
      }
    }
  ];

  /**
    추진사항 데이터
   */
  const promoSlideData = [
    {
      id: 0,
      icon: require('assets/images/pages/intro/intro-icon-1.svg').default,
      title: '지역확대',
      desc: '총 13개 지역 내 SW미래채움센터 구축·운영을 통한 전 지역 빈틈없는 SW교육 추진',
      local: '* 강원, 경남, 인천, 전남, 충북, 경기, 경북, 울산, 충남, 제주, 대구, 광주, 전북'
    },
    {
      id: 1,
      icon: require('assets/images/pages/intro/intro-icon-2.svg').default,
      title: 'SW교육 운영',
      desc: ['(초중) 코딩프로젝트 챌린지', '(고등) 글로벌 AI·SW교육 프로그램']
    },
    {
      id: 2,
      icon: require('assets/images/pages/intro/intro-icon-3.svg').default,
      title: '강사양성',
      desc: ['강사 수업과정안 공모전', '강사 네트워킹데이 개최']
    }
  ];

  return (
    <>
      <Visual category="introduction" title="소개" />
      <Breadcrumbs category="introduction" />
      <Section p="0" pb={isMobile ? 'var(--space-18)' : 'var(--space-35)'} className="introduction-wrap">
        <Container size={isMobile ? '1' : '4'}>
          <PageTitle icon="school" title="사업소개" />

          {/* 사업목적 */}
          <Box className="intro-goal-text" mb={isMobile ? 'var(--space-4)' : 'var(--space-10)'}>
            <Heading as="h4" className={isMobile ? 'sub-title' : 'title5'}>
              사업목적
            </Heading>
            <Text as="p" className="body2-description">
              <span className="font-bold">지역 내 SW교육 접근성을 확보</span>
              하고, 초·중등교육 단계에서부터의 체계적인 디지털 교육을 추진하여{' '}
              <span className="font-bold">디지털 소양을 갖춘 지역 인재 양성 기반 마련</span>
            </Text>
          </Box>
          <Box className="intro-goal-box" mb={isMobile ? 'var(--space-9)' : 'var(--space-20)'}>
            {!isMobile ? (
              <Flex justify="between">
                {goalSlideData.map(item => (
                  <Flex direction="column" className="goal-item">
                    <Box className="image-wrap">
                      <img src={item.src} alt="" />
                    </Box>
                    <Box className="text-wrap">
                      <Text as="p" className="sub-title">
                        {item.title}
                      </Text>
                      <ul className="dots">
                        {item.list.map((el, idx) => (
                          <li className="body1" key={idx} dangerouslySetInnerHTML={{ __html: el }}></li>
                        ))}
                      </ul>
                    </Box>
                  </Flex>
                ))}
              </Flex>
            ) : (
              <Box className="intro-goal-slider">
                <Swiper modules={[Pagination]} pagination={{ clickable: true }} loop slidesPerView={1.2} spaceBetween={16}>
                  {goalSlideData.map(item => (
                    <SwiperSlide key={item.id} className="goal-item">
                      <Box className="image-wrap">
                        <img src={item.src} alt="" />
                      </Box>
                      <Box className="text-wrap">
                        <Text as="p" className="body2 font-bold">
                          {item.title}
                        </Text>
                        <ul className="dots">
                          {item.list.map((el, idx) => (
                            <li key={idx} dangerouslySetInnerHTML={{ __html: el }}></li>
                          ))}
                        </ul>
                      </Box>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Box>
            )}
          </Box>

          {/* 주요성과 */}
          <Box mb={isMobile ? 'var(--space-9)' : 'var(--space-20)'} className="performance-wrap">
            <Text as="p" mb={isMobile ? 'var(--space-4)' : 'var(--space-10)'} className="title5">
              SW미래채움 주요성과
            </Text>
            {!isMobile ? (
              <Box className="performance-box">
                {keyDataList.map(({ gridHeader, gridBody }, idx) => (
                  <Grid columns="repeat(5, minmax(132px, auto))" gapX="var(--space-2)" key={idx}>
                    {gridHeader.map((item, i) => (
                      <Flex
                        key={i}
                        align="center"
                        justify={item.icon ? 'start' : 'center'}
                        gap="var(--space-4)"
                        className="performace-item-head"
                      >
                        {item.icon && <img src={item.icon} alt="" />}
                        <Text className="body1 font-bold">{item.title}</Text>
                      </Flex>
                    ))}
                    {gridBody.map((el, i) => (
                      <Fragment key={i}>
                        <Flex align="center" justify="center" className="performace-item-body">
                          <Text className="title5 year">{el.year}</Text>
                        </Flex>

                        <Flex direction="column" align="center" justify="center" gap="var(--space-4)" className="performace-item-body">
                          <Text className="title5 local">{el.local_num}개 지역</Text>
                          <ul className="dots">
                            {el.local_prev_list && (
                              <li className="body2 dots-bg-red">
                                <span className="body2 font-bold">(계속)</span> {el.local_prev_list}
                              </li>
                            )}
                            {el.local_new_list && (
                              <li className="body2 dots-bg-red">
                                <span className="body2 font-bold">(신규)</span> {el.local_new_list}
                              </li>
                            )}
                          </ul>
                        </Flex>

                        <Flex align="center" justify="center" className="performace-item-body">
                          <Text className="title5 edu">{el.student}명 양성</Text>
                        </Flex>

                        <Flex direction="column" align="center" justify="center" gap="var(--space-4)" className="performace-item-body">
                          <Text className="title5 person">{el.person}명</Text>
                          <ul className="dots">
                            <li className="body2 dots-bg-green">
                              찾아가는 교육 : {el.edu}명({el.percent})
                            </li>
                          </ul>
                        </Flex>

                        <Flex direction="column" align="start" justify="center" gap="var(--space-4)" className="performace-item-body">
                          <ul className="dots">
                            {el.history.map((li, i) => (
                              <li key={i} className="body2 dots-bg-blue">
                                {li}
                              </li>
                            ))}
                          </ul>
                        </Flex>
                      </Fragment>
                    ))}
                  </Grid>
                ))}
              </Box>
            ) : (
              <Fragment>
                {keyDataListMo.map(item => (
                  <Flex key={item.id} direction={'column'} className="performace-item">
                    <Box className="year-item">
                      <Text as="p" className="font-bold">
                        {item.year}
                      </Text>
                    </Box>
                    {/* center */}
                    <Box className="center-item">
                      <Text as="p" className="body1 font-bold">
                        {item.center.title}
                      </Text>
                      <Text as="p" className="body1 font-bold">
                        {item.center.total}
                      </Text>
                      <ul className="dots">
                        {item.center.local.map(el => (
                          <li className="dots-bg-red" dangerouslySetInnerHTML={{ __html: el }}></li>
                        ))}
                      </ul>
                    </Box>
                    {/* teacher */}
                    <Box className="teacher-item">
                      <Text as="p" className="body1 font-bold">
                        {item.teacher.title}
                      </Text>
                      <Text as="p" className="body1 font-bold">
                        {item.teacher.total}
                      </Text>
                    </Box>
                    {/* education */}
                    <Box className="education-item">
                      <Text as="p" className="body1 font-bold">
                        {item.education.title}
                      </Text>
                      <Text as="p" className="body1 font-bold">
                        {item.education.total}
                      </Text>
                      <ul className="dots">
                        <li className="dots-bg-green">{item.education.edu}</li>
                      </ul>
                    </Box>
                    {/* promotion */}
                    <Box className="promo-item">
                      <Text as="p" className="body1 font-bold">
                        {item.promotion.title}
                      </Text>
                      <ul className="dots">
                        {item.promotion.list.map(list => (
                          <li className="dots-bg-blue">{list}</li>
                        ))}
                      </ul>
                    </Box>
                  </Flex>
                ))}
                <Flex align={'start'} gap={'var(--space-1)'} className="performace-noti">
                  <img src={require('assets/images/icon/icon-noti-error.svg').default} alt="" />
                  <Text as="p" className="body3">
                    2019년부터 2023년까지 SW미래채움 센터구축, SW전문강사 양성, 초·중등학생 교육 운영, 총 3항목에 대한 성과 전시
                  </Text>
                </Flex>
              </Fragment>
            )}
          </Box>

          {/* 추진사항 */}
          <Box mb={!isMobile && 'var(--space-20)'} className="promotion-wrap">
            <Text as="p" mb={isMobile ? 'var(--space-4)' : 'var(--space-10)'} className="title5">
              주요 성과내 주요 추진사항
            </Text>
            {!isMobile ? (
              <Flex justify="between" gap="var(--space-15)" className="promotion-box">
                {promoSlideData.map(item => (
                  <Box key={item.id} className="promotion-item">
                    <Box className="icon-wrap">
                      <img src={item.icon} alt="" />
                    </Box>
                    <Text as="p" className="sub-title">
                      {item.title}
                    </Text>
                    {item.id === 0 ? (
                      <Text as="p" mb="var(--space-6)" className="body2">
                        {item.desc}
                      </Text>
                    ) : (
                      <ul className="dots">
                        {item.desc.map((el, idx) => (
                          <li key={idx} className="body2 dots-bg-blue">
                            {el}
                          </li>
                        ))}
                      </ul>
                    )}
                    {item.local && (
                      <Text as="span" className="body3">
                        * 강원, 경남, 인천, 전남, 충북, 경기, 경북, 울산, 충남, 제주, 대구, 광주, 전북
                      </Text>
                    )}
                  </Box>
                ))}
              </Flex>
            ) : (
              <Swiper modules={[Pagination]} pagination={{ clickable: true }} loop className="promotion-box">
                {promoSlideData.map(item => (
                  <SwiperSlide key={item.id} className="promotion-item">
                    <Box className="icon-wrap">
                      <img src={item.icon} alt="" />
                    </Box>
                    <Box className="text-wrap">
                      <Text as="p" className="body1 font-bold">
                        {item.title}
                      </Text>
                      {item.id === 0 ? (
                        <Text as="p" mb="var(--space-2)" className="body2">
                          {item.desc}
                        </Text>
                      ) : (
                        <ul className="dots">
                          {item.desc.map((el, idx) => (
                            <li key={idx} className="body2 dots-bg-blue">
                              {el}
                            </li>
                          ))}
                        </ul>
                      )}
                      {item.local && (
                        <Text as="span" className="body3">
                          * 강원, 경남, 인천, 전남, 충북, 경기, 경북, 울산, 충남, 제주, 대구, 광주, 전북
                        </Text>
                      )}
                    </Box>
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </Box>
        </Container>
      </Section>
    </>
  );
}
